export const SIGNUP_PATH = '/sign_up/';
export const LOGIN_PATH = '/login/';
export const POST_AUTH_PATH = '/dashboard/';
export const PERPAY_PLUS_SOLO_APPLICATION = '/plus/application';
